export const enum IDP_APP {
  COMMON = 'COMMON'
}

export const enum EndpointKey {
  MFA_OAUTH_URL = 'MFA_OAUTH_URL'
}

export const MFA_OAUTH_URL =
  '/content/dam/delta-applications/login/mfa-oauth.json';

export const AUTHENTICATION_REQUIRED = 'AUTHENTICATION_REQUIRED';
export const MFA_COMPLETED = 'MFA_COMPLETED';
export const PUSH_CONFIRMATION_WAITING = 'PUSH_CONFIRMATION_WAITING';
export const PUSH_CONFIRMATION_REJECTED = 'PUSH_CONFIRMATION_REJECTED';
export const PUSH_CONFIRMATION_TIMED_OUT = 'PUSH_CONFIRMATION_TIMED_OUT';
export const FAILED = 'FAILED';
export const PASSWORD_RESET_REQUIRED = 'PASSWORD_RESET_REQUIRED';
export const DEVICE_PAIRING_METHOD_REQUIRED = 'DEVICE_PAIRING_METHOD_REQUIRED';
export const DEVICE_SELECTION_REQUIRED = 'DEVICE_SELECTION_REQUIRED';
export const OTP_REQUIRED = 'OTP_REQUIRED';
export const ACCOUNT_RECOVERY_ERROR = 'ACCOUNT_RECOVERY_ERROR';
export const ERROR_MSG_TIMEOUT_ERROR = 'ERROR_MSG_TIMEOUT_ERROR';
export const REMAINING_ATTEMPT = 5;
